export function isVehicleCreated(vehicle, t) {
  return vehicle.year !== t('modal.add_vehicle.year_placeholder') && vehicle.make_id !== t('modal.add_vehicle.make_placeholder') && vehicle.model_id !== t('modal.add_vehicle.model_placeholder') && vehicle.trim_id !== t('modal.add_vehicle.trim_placeholder');
}

export function formatMileageAsOf(date) {
  const options = { year: 'numeric', month: 'short', day: '2-digit' };
  if (date) {
    date = new Date(date);
    return date.toLocaleDateString('en-US', options);
  } else {
    return '';
  }
}